// tanstack
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/$accountId/_user/energyxplorer/portfolio/overview/',
)({
  beforeLoad: () =>
    redirect({
      to: 'building',
      replace: true,
    }),
});
